import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function dateEndSettedOrUndefined(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    const date = control.value as Date;

    if (date === null) {
      return { required: true } // same implementation of Validaros.required
    }

    if (date === undefined) {
      return null;
    }

    return null;
  };
}
